import './styles.scss';

import React from 'react';
import PropTypes from 'prop-types';

import InputLabel from 'Components/forms2/InputLabel';
import InputHelper from 'Components/forms2/InputHelper';
import ErrorMessage from 'Components/forms2/ErrorMessage';
import InputIcon from 'Components/forms2/InputIcon';
import InputCharCounter from 'Components/forms2/InputCharCounter';

export default class FormInputComponent extends React.Component {
    static displayName = 'FormInputComponent';
    static propTypes = {
        onChange: PropTypes.func,
        onFormChange: PropTypes.func,

        name: PropTypes.string.isRequired,
        type: PropTypes.string,
        placeholder: PropTypes.string,
        label: PropTypes.string,
        helper: PropTypes.string,
        value: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
        ]),
        icon: PropTypes.object,
        inputProps: PropTypes.object,

        errorMessage: PropTypes.string,
        customRequiredError: PropTypes.string,

        disabled: PropTypes.bool,
        required: PropTypes.bool,

        charCounter: PropTypes.bool,
        maxChars: PropTypes.number
    };
    static defaultProps = {
        type: 'text',
        placeholder: '',
        label: '',
        helper: '',
        value: '',

        errorMessage: '',

        required: false,
        disabled: false,

        charCounter: false,
        maxChars: null,
        inputProps: {},
    }

    onChange = event => {
        const data = {
            name: event.target.name,
            value: event.target.value
        };

        if (this.props.onChange) {
            this.props.onChange(data);
        }

        if (this.props.onFormChange) {
            this.props.onFormChange(data);
        }

        return data;
    }

    render() {
        const { value, name, type, placeholder, label, errorMessage, required, disabled, helper, charCounter, maxChars, icon, inputProps } = this.props;

        const finalProps = {
            id: name,
            type: type,
            name: name,
            onChange: this.onChange,
            placeholder: placeholder,
            value: value || '',
            required: required,
            disabled: disabled,
            ...inputProps,
        };

        return (
            <div className={`component-form-input form-element-${name}`}>
                {label && <InputLabel label={label} />}
                <div className="input-wrapper">
                    {icon && <InputIcon icon={icon} />}
                    {charCounter && <InputCharCounter value={value} maxChars={maxChars} />}
                    <input {...finalProps} />
                </div>
                {helper && <InputHelper message={helper} />}
                {errorMessage && <ErrorMessage message={errorMessage} />}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/forms2/Input/index.js